import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingMessages } from '../../../utils/constants/guest-messages';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { useGetAllGuestsSearchHistoryQuery, useGetGuestDetailsInfoMutation, useRemoveGuestInfoMutation } from '../../../store/reservations/reservationsApi';
import GuestInfoModal from './modals/GuestInfoModal';
import ConfirmDeleteModal from './modals/ConfirmDeleteModal';
import GuestsTable from './tables/GuestsTable';
import Button from '../../../shared/button';
import Input from '../../../shared/input';


const GuestsInfo = () => {
    const navigate = useNavigate();
    const [showGuestModal, setShowGuestModal] = useState<{ show: boolean, data: any }>();
    const [showDeleteModal, setShowDeleteModal] = useState<{ show: boolean, data: any }>();
    const [search, setSearch] = useState<any>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [loadingText, setLoadingText] = useState(LoadingMessages[0]);
    const { data, isLoading, refetch } = useGetAllGuestsSearchHistoryQuery({ ...paginationState, data: { search: search } });
    const [getGuestDetailsInfo, { isLoading: isLoadingGuestInfo }] = useGetGuestDetailsInfoMutation();
    const [removeGuestInfo, { isLoading: isLoadingDelete }] = useRemoveGuestInfoMutation();

    const onGoBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        if (!isLoadingGuestInfo) {
            setLoadingText(LoadingMessages[0]);
            return;
        }

        let index = 0;
        const interval = setInterval(() => {
            index = (index + 1) % LoadingMessages.length;
            setLoadingText(LoadingMessages[index]);
        }, 5000);

        return () => clearInterval(interval);
    }, [isLoadingGuestInfo]);

    const onChangeSearch = (e: any) => {
        setSearch(e)
    }

    const onSeeGuestsDetails = (data: any) => {
        setShowGuestModal({
            show: true,
            data: data,
        })
        document.body.style.overflow = 'hidden';
    }

    const onSearchMoreClicked = async () => {
        if (search && search !== '') {
            try {
                const guestInfoData = {
                    name: search
                }
                const response: any = await getGuestDetailsInfo(guestInfoData).unwrap();
                onSeeGuestsDetails(response?.data)
                setSearch(undefined)
                refetch()
            } catch (err) {
                // err here
            }
        }
    }

    const onCloseModal = () => {
        setShowGuestModal(undefined)
        setShowDeleteModal(undefined)
        document.body.style.overflow = 'auto';
    }

    const onDeleteGuest = async () => {
        try {
            await removeGuestInfo(showDeleteModal?.data?._id || showDeleteModal?.data?.id).unwrap();
            refetch();
            onCloseModal()
        } catch (err) {
            // err here
        }
    }

    const onDeleteRequest = (data: any) => {
        setShowDeleteModal({
            show: true,
            data: data,
        })
        document.body.style.overflow = 'hidden';
    }

    return (
        <div>
            <div className={'flex flex-row items-center justify-between mb-10'}>
                <div className='flex flex-row items-center'>
                    <div onClick={onGoBack} className='md:-ml-2 xl:-ml-1 md:mr-2 xl:mr-4'>
                        <img src={'/assets/shared/go-back.svg'} className={'w-[18px] object-contain cursor-pointer'} />
                    </div>
                    <p className='page-title'>Guests Search History</p>
                </div>
            </div>
            <div>
                <div className={`flex flex-row justify-between items-center bg-call-default mt-3 p-1 !rounded mb-2`}>
                    <Input
                        placeholder={'Search for Guest'}
                        dataQa={'search'}
                        containerStyle='mb-0 pb-0 relative min-w-[60%]'
                        inputStyle={`mb-0 border-0 focus:outline-none`}
                        icon={'/assets/shared/search.svg'}
                        showValue={true}
                        inputValue={search}
                        inputUniqueName={'search'}
                        onChangeInput={onChangeSearch}
                        hideInputSpace={true}
                    />
                    {isLoadingGuestInfo ?
                        <p className="px-2 py-2 text-primary-default">{loadingText}</p>
                        : <Button
                            label={'Expand Search'}
                            className={search ? "btn-primary-rounded-less" : 'btn-primary-rounded-less-disable'}
                            onClickButton={() => search && onSearchMoreClicked()}
                        />
                    }
                </div>
                <GuestsTable
                    rows={data?.data?.elements || []}
                    paginationData={data?.data.page}
                    rowsLoading={isLoading}
                    onSeeGuestsDetails={onSeeGuestsDetails}
                    setPaginationState={setPaginationState}
                    onDeleteRequest={onDeleteRequest}
                />
            </div>
            {showGuestModal?.show &&
                <GuestInfoModal
                    openModal={showGuestModal?.show}
                    data={showGuestModal?.data || ''}
                    handleCloseModal={onCloseModal}
                />
            }
            {showDeleteModal?.show &&
                <ConfirmDeleteModal
                    openModal={showDeleteModal?.show}
                    loading={isLoadingDelete}
                    onApproveAction={onDeleteGuest}
                    handleCloseModal={onCloseModal}
                />
            }
        </div>
    )
}
export default GuestsInfo;